/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmptyCMADto
 */
export interface CreateEmptyCMADto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmptyCMADto
     */
    agentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmptyCMADto
     */
    clientDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmptyCMADto
     */
    presentationType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmptyCMADto
     */
    presentationName?: string;
}

/**
 * Check if a given object implements the CreateEmptyCMADto interface.
 */
export function instanceOfCreateEmptyCMADto(value: object): value is CreateEmptyCMADto {
    if (!('presentationType' in value) || value['presentationType'] === undefined) return false;
    return true;
}

export function CreateEmptyCMADtoFromJSON(json: any): CreateEmptyCMADto {
    return CreateEmptyCMADtoFromJSONTyped(json, false);
}

export function CreateEmptyCMADtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmptyCMADto {
    if (json == null) {
        return json;
    }
    return {
        
        'agentId': json['agentId'] == null ? undefined : json['agentId'],
        'clientDisplayName': json['clientDisplayName'] == null ? undefined : json['clientDisplayName'],
        'presentationType': json['presentationType'],
        'presentationName': json['presentationName'] == null ? undefined : json['presentationName'],
    };
}

export function CreateEmptyCMADtoToJSON(json: any): CreateEmptyCMADto {
    return CreateEmptyCMADtoToJSONTyped(json, false);
}

export function CreateEmptyCMADtoToJSONTyped(value?: CreateEmptyCMADto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'agentId': value['agentId'],
        'clientDisplayName': value['clientDisplayName'],
        'presentationType': value['presentationType'],
        'presentationName': value['presentationName'],
    };
}

